export const APP_ROUTES = {
  notFound: 'not-found',
  edit: 'edit',

  auth: {
    index: '/auth/*',
    logIn: 'login',
    createPassword: 'create-password',
  },

  user: {
    index: '/*',
    dashboard: '/',
    scheduler: '/scheduler',

    settings: {
      index: '/settings/*',
      details: 'details',
      team: 'team',
      configuration: 'configuration',
      billing: 'billing',
      notifications: 'notifications',
    },
    profile: {
      index: '/profile/*',
      details: {
        index: '/profile/:id/*',
        info: 'details',
      },
      password: 'password',
      notifications: 'notifications',
      connectedAccounts: 'connected-accounts',
    },
    dancers: {
      index: '/students',
      create: '/students/create',
      notifications: 'students/:id/notifications',
      details: {
        index: '/students/:id/*',
        info: 'details',
        routines: 'progress',
        notifications: 'notifications',
        performances: 'showcases',
        media: 'media',
        appointmentHistory: 'appointment-history',
      },
    },
    parents: {
      index: '/guardians',
      create: '/guardians/create',
      notifications: '/guardians/:id/notifications',
      details: {
        index: '/guardians/:id/*',
        info: 'details',
        notifications: 'notifications',
      },
    },
    team: {
      index: '/team',
      create: '/member/create',
      details: {
        info: 'details',
        index: '/members/:id/*',
      },
    },
    classes: {
      index: '/sessions',
      create: '/sessions/create',
      details: {
        index: '/sessions/:id/*',
        info: 'details',
        dancers: 'students',
        schedule: 'schedule',
        scheduleEdit: 'schedule/edit',
        pricing: 'pricing',
        pricingEdit: 'pricing/edit',
      },
    },
    routines: {
      index: '/progress',
      create: '/progress/create',

      details: {
        index: '/progress/:id/*',
        info: 'details',
        performances: 'showcases',
        medias: 'medias',
      },
    },
    events: {
      index: '/events',
      create: '/events/create',

      details: {
        index: '/events/:id/*',
        info: 'details',
        performances: 'showcases',
      },
    },
    performances: {
      create: '/showcases/create',

      details: {
        index: '/showcases/:id/*',
        info: 'details',
        dancers: 'students',
      },
    },
    invoices: {
      index: '/invoices',
      create: '/invoices/invoices',

      details: {
        index: '/invoices/:id/details',
        edit: '/invoices/:id/edit',
        info: 'details',
      },
    },
    billing: {
      index: '/billing',
      plans: '/billing/plans',
      checkout: '/billing/checkout',
    },
    media: {
      index: '/media',
      details: '/media/:id',
    },
  },
};
